import { createContext, ReactNode, useContext, useReducer } from "react";
import { InitialContext } from "../../../../../types/state/context";
import { CreatePrintingTechniqueReducer } from "../../../state/printingTechnique/create";
import { CreatePrintingTechniqueState, CreatePrintingTechniqueTypes } from "../../../state/printingTechnique/create/data";

type Context = InitialContext<
  CreatePrintingTechniqueState,
  CreatePrintingTechniqueTypes
>;
export const CreatePrintingTechniqueContext = createContext<Context>(
  {} as Context,
);

export const CreatePrintingTechniqueProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(
    CreatePrintingTechniqueReducer.reducer,
    CreatePrintingTechniqueReducer.initialState,
  );

  return (
    <CreatePrintingTechniqueContext.Provider value={{ state, dispatch }}>
      {children}
    </CreatePrintingTechniqueContext.Provider>
  );
};

export const useCreatePrintingTechniqueStore = () =>
  useContext(CreatePrintingTechniqueContext);
